import script from "./AddNewUsers.vue?vue&type=script&setup=true&lang=js"
export * from "./AddNewUsers.vue?vue&type=script&setup=true&lang=js"

import "./AddNewUsers.vue?vue&type=style&index=0&id=a85034f4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a85034f4"]])

export default __exports__